import Vue from 'vue';
export default Vue.extend({
    name: 'HeaderBackground',
    props: {
        colors: {
            type: Object,
            required: true
        }
    },
    computed: {
        colorsStyle() {
            return {
                '--hbg-darkest': this.colors.darkest,
                '--hbg-medium-dark': this.colors.mediumDark,
                '--hbg-medium-light': this.colors.mediumLight,
                '--hbg-lightest': this.colors.lightest
            };
        }
    }
});
